import { useState } from 'react';
import './HelpButton.css';

const HELP_BUTTON_LABEL = 'Open help';
const HELP_BUTTON_TEXT = '?';
const HELP_BUTTON_SEEN_STORAGE_KEY = 'help_button_seen';

export interface HelpButtonProps {
  onClick: () => void;
  isHidden?: boolean;
}

/**
 * Renders the floating action button that opens the contextual help drawer.
 *
 * @param props.onClick Called when the user opens the help drawer.
 * @param props.isHidden Hides the button while the drawer is open to avoid overlap.
 */
export default function HelpButton({ onClick, isHidden = false }: HelpButtonProps) {
  const [hasSeenPulse, setHasSeenPulse] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return true;
    }

    return window.localStorage.getItem(HELP_BUTTON_SEEN_STORAGE_KEY) === 'true';
  });

  const handleClick = () => {
    if (!hasSeenPulse && typeof window !== 'undefined') {
      window.localStorage.setItem(HELP_BUTTON_SEEN_STORAGE_KEY, 'true');
      setHasSeenPulse(true);
    }

    onClick();
  };

  return (
    <button
      type='button'
      className={`help-button${hasSeenPulse ? '' : ' help-button--pulse'}${isHidden ? ' help-button--hidden' : ''}`}
      aria-label={HELP_BUTTON_LABEL}
      title={HELP_BUTTON_LABEL}
      onClick={handleClick}
    >
      <span aria-hidden='true'>{HELP_BUTTON_TEXT}</span>
    </button>
  );
}
